// extracted by mini-css-extract-plugin
module.exports = {"homeContainer":"home_homeContainer__3As-Y","list":"home_list__1i3eM","head":"home_head__3VHxL"};